import resolveConfig from 'tailwindcss/resolveConfig';
import { TailwindConfig } from 'tailwindcss/tailwind-config';
import tailwindConfig from '../tailwind.config.js';

// @ts-ignore
const fullConfig = resolveConfig(tailwindConfig);

export const useTailwindConfig = (): TailwindConfig => fullConfig;
